exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.totals-statistics[data-v-6937d97a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  background: #3f4247;\n  -webkit-box-shadow: 0 2px 0 rgba(33, 37, 41, 0.0263604);\n          box-shadow: 0 2px 0 rgba(33, 37, 41, 0.0263604);\n  border-radius: 2px;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 7px;\n}\n.statistics-heading[data-v-6937d97a] {\n  color: white;\n  font-weight: 500;\n  font-size: 12px;\n}\n.total-amount[data-v-6937d97a] {\n  font-size: 17px;\n  width: 28%;\n}\n.total-hours[data-v-6937d97a] {\n  font-size: 17px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6937d97a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reports/MoverTotalsStatistics.vue
// module id = XeOx
// module chunks = 0